import { render, staticRenderFns } from "./SoundCloudEmbed.vue?vue&type=template&id=8baac3d4"
import script from "./SoundCloudEmbed.vue?vue&type=script&lang=js"
export * from "./SoundCloudEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports